import { DialogDivider, DialogDividerProps } from '../Dialog';

type ModalDividerProps = DialogDividerProps;

const ModalDivider = (props: ModalDividerProps): JSX.Element => <DialogDivider {...props} />;

export { ModalDivider };
export type { ModalDividerProps };
